<div class="content_main-container" *ngrxLet="addresses$ as addresses">
  <div style="display: flex; align-items: center">
    @if (continueToReview) {
    <button
      mat-icon-button
      class="back-btn"
      [attr.aria-label]="'ARIA_LABEL.BACK' | translate"
      id="header_back-btn"
      routerLink=".."
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    }
    <div class="flex-row flex-full-width mb-24">
      <h1 id="checkout_view_address_title">{{ 'USER_PORTAL.MANAGE_SHIPPING_ADDRESSES.TITLE' | translate }}</h1>
      @if(!isGuestCheckout){
      <ng-container *ngrxLet="maxAddress$ as maxAddress">
        <div class="content_main-button-list" style="align-items: end !important">
          <a
            [class.disabled-link]="!(maxAddress === -1 || maxAddress > (addresses?.length || 0))"
            id="link-bank_href"
            class="mb-8"
            [routerLink]="['./add']"
            id="add_another_address_href"
          >
            <pbb-svg-icon
              [icon]="'add-btn'"
              [title]="'COMMON.VIEW_ADDRESS.BUTTON_ADD_ADDRESS' | translate"
              class="icon-md"
            ></pbb-svg-icon>
          </a>
        </div>
      </ng-container>
      }
    </div>
  </div>
  <ng-container *ngrxLet="registerStatus$ as registerStatus">
    @if (registerStatus === RegisteredUser ? false : !isAddressChanged) {
    <pbb-address-suggestion *ngrxLet="selectedFI$ as selectedFI" [financialInstitution]="selectedFI">
    </pbb-address-suggestion>
    }
  </ng-container>
  <ng-container *ngrxLet="isValidSelectedAddress$ as isValidSelectedAddress">
    <ng-container *ngrxLet="shippingCost$ as shippingCost">
      @if (shippingCost?.data?.shipping_cost !== null) {
      <pbb-notice [type]="noticeType.ERROR" title="{{ 'COMMON.ERROR.SHIPPING.MESSAGE_ALT' | translate }}"></pbb-notice>
      }
    </ng-container>

    @if (!isValidSelectedAddress) {
    <pbb-notice
      id="incomplete-address-error-notice"
      [type]="noticeType.ERROR"
      title="{{ 'COMMON.ERROR.SHIPPING.INCOMPLETE_ADDRESS' | translate }}"
    ></pbb-notice>
    }
    <ng-container *ngrxLet="maxAddress$ as maxAddress">
      @if (!(maxAddress === -1 || maxAddress > (addresses?.length || 0))) {
      <div class="mb-16">
        <pbb-notice-banner
          id="user-portal_address-limit-info"
          [noticeVariant]="'info'"
          [noticeTitle]="'COMMON.MAX_SHIPPING_ADDRESS_LIMIT_TITLE' | translate"
          [noticeMessage]="'COMMON.MAX_SHIPPING_ADDRESS_LIMIT' | translate : { shippingAddressLimit: maxAddress }"
          [showCloseButton]="false"
          [noticeIcon]="'error'"
          [duration]="0"
        ></pbb-notice-banner>
      </div>
      }
    </ng-container>
    <ng-container *ngrxLet="selectedShippingAddressRef$ as selectedShippingAddressRef">
      <ng-container *ngrxLet="defaultShippingAddressRef$ as defaultShippingAddressRef">
        <ng-container>
          <pbb-address-list
            [addresses]="addresses"
            [showMenuButton]="!isGuestCheckout"
            (clickShippingAddress)="setShippingAddress($event)"
            [selectedShippingAddressRef]="selectedShippingAddressRef"
            [defaultShippingAddressRef]="defaultShippingAddressRef"
            (menuAction)="setMenuAction($event)"
          >
          </pbb-address-list>
        </ng-container>
      </ng-container>
    </ng-container>

    <div class="content_main-button-list" style="align-items: end !important">
      <div class="sticky-container">
        <div class="sticky-main">
          @if (!isGuestCheckout) {
          <pbb-button
            routerLink=".."
            mat-flat-button
            color="primary"
            id="checkout_view_address_button_continue"
            [disabled]="!isValidSelectedAddress"
          >
            {{ 'COMMON.BUTTON.CONTINUE' | translate }}
          </pbb-button>
          } @else {
          <pbb-button
            routerLink=".."
            mat-flat-button
            color="primary"
            id="checkout_view_address_button_continue"
            [disabled]="!isValidSelectedAddress"
          >
            {{ 'COMMON.BUTTON.CONTINUE' | translate }}
          </pbb-button>
          <pbb-button
            mat-flat-button
            color="accent"
            id="checkout_view_address_button_change_address"
            [routerLink]="['./edit/' + selectedAddressIndex]"
            [state]="{selectedAddress: addresses[selectedAddressIndex]} "
          >
            {{ 'COMMON.VIEW_ADDRESS.BUTTON_CHANGE_ADDRESS' | translate }}
          </pbb-button>
          }
        </div>
      </div>
    </div>
  </ng-container>
</div>
